import PropTypes from 'prop-types';

export const MUTATION_OPTIONS = {
  attributeFilter: PropTypes.arrayOf(PropTypes.string),
  attributeOldValue: PropTypes.arrayOf(PropTypes.string),
  attributes: PropTypes.bool,
  characterData: PropTypes.bool,
  characterDataOldValue: PropTypes.bool,
  childList: PropTypes.bool,
  subtree: PropTypes.bool,
};

export const MUTATION_TYPES = {
  children: PropTypes.func,
  observerOptions: PropTypes.shape(MUTATION_OPTIONS),
  onMutation: PropTypes.func,
};
